var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('edit-live-settings-form',{attrs:{"live":_vm.live}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }